(() => {
  const notifyButtonSelector = '[data-stoq-quickview-notify]';

  function getQuickViewProductData(context) {
    const root = context?.closest?.('#ProductInfo-quick-view') || context?.closest?.('.quick-view') || context || document;
    const script = root.querySelector?.('[data-stoq-quickview-product-json]');

    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Unable to parse STOQ quick view product data.', error);
      return null;
    }
  }

  function getVariant(productData, variantId) {
    if (!productData || !Array.isArray(productData.variants) || !variantId) return null;

    return productData.variants.find((variant) => String(variant.id) === String(variantId)) || null;
  }

  function updateStoqQuickViewNotify(context = document) {
    context.querySelectorAll?.(notifyButtonSelector).forEach((button) => {
      const root = button.closest('#ProductInfo-quick-view') || button.closest('.quick-view') || document;
      const form = button.closest('form') || root.querySelector('form[data-type="add-to-cart-form"]');
      const variantInput = form?.querySelector('input[name="id"]') || root.querySelector('input[name="id"]');
      const variantId = variantInput?.value || button.dataset.variantId;
      const productData = getQuickViewProductData(root);
      const selectedVariant = getVariant(productData, variantId);
      const addToCartButton = form?.querySelector('.add_to_cart_button') || root.querySelector('.add_to_cart_button');
      const isAvailable = selectedVariant ? selectedVariant.available : addToCartButton?.dataset.available === 'true';

      button.dataset.variantId = variantId || '';
      button.classList.toggle('hidden', !variantId || isAvailable);

      if (addToCartButton) {
        addToCartButton.classList.toggle('hidden', !!variantId && !isAvailable);
      }
    });
  }

  function openStoqQuickViewModal(button, attempt = 0) {
    const productData = getQuickViewProductData(button);
    const variantId = button.dataset.variantId;

    if (!productData || !variantId) return;

    if (window._RestockRocket?.openModal) {
      window._RestockRocket.openModal(productData, variantId);
      return;
    }

    if (attempt < 20) {
      setTimeout(() => openStoqQuickViewModal(button, attempt + 1), 250);
    } else {
      console.warn('STOQ API is not available for quick view notify button.');
    }
  }

  function protectStoqPopupEvents(context = document) {
    context.querySelectorAll?.('.restock-rocket-wrapper').forEach((wrapper) => {
      if (wrapper.dataset.stoqQuickviewProtected === 'true') return;

      wrapper.dataset.stoqQuickviewProtected = 'true';
      ['click', 'mousedown', 'mouseup', 'pointerdown', 'touchstart'].forEach((eventName) => {
        wrapper.addEventListener(eventName, (event) => event.stopPropagation());
      });
    });
  }

  function getSelectedQuickViewVariantId(root) {
    const form = root.querySelector?.('form[data-type="add-to-cart-form"]') || root.querySelector?.('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"], select[name="id"]')
      || root.querySelector?.('input[name="id"], select[name="id"]');

    return variantInput?.value || '';
  }

  function getBssQuickViewIds(quickViewForm) {
    const productData = getQuickViewProductData(quickViewForm);
    const variantId = getSelectedQuickViewVariantId(quickViewForm)
      || quickViewForm.querySelector?.('[bss-b2b-variant-id]')?.getAttribute('bss-b2b-variant-id')
      || productData?.variants?.[0]?.id
      || '';
    const productId = productData?.id
      || quickViewForm.querySelector?.('[bss-b2b-product-id]')?.getAttribute('bss-b2b-product-id')
      || '';

    return {
      productData,
      productId,
      variantId
    };
  }

  function getBssQuickViewElements(context = document) {
    const quickViewContent = context?.id === 'quickview-product-content'
      ? context
      : context?.querySelector?.('#quickview-product-content') || document.getElementById('quickview-product-content');
    const root = quickViewContent || context || document;
    const quickViewForm = root.querySelector?.('[bss-b2b-quickview-product-form]')
      || root.closest?.('[bss-b2b-quickview-product-form]')
      || root.querySelector?.('#ProductInfo-quick-view')
      || root;
    const { productData, productId, variantId } = getBssQuickViewIds(quickViewForm);
    const variantInput = quickViewForm.querySelector?.('input[name="id"], select[name="id"]')
      || root.querySelector?.('input[name="id"], select[name="id"]');
    const priceElements = root.querySelectorAll?.('[bss-b2b-product-price]') || [];

    return {
      root,
      quickViewForm,
      productData,
      productId,
      variantId,
      variantInput,
      priceElements
    };
  }

  function syncBssQuickViewAttributes(elements) {
    const { quickViewForm, productId, variantId, priceElements } = elements;

    if (!quickViewForm || !productId || !variantId || !priceElements.length) return false;

    quickViewForm.setAttribute('bss-b2b-quickview-product-form', '');

    priceElements.forEach((priceElement) => {
      priceElement.setAttribute('bss-b2b-product-id', String(productId));
      priceElement.setAttribute('bss-b2b-variant-id', String(variantId));
      priceElement.setAttribute('bss-b2b-product-price', '');
      priceElement.setAttribute('bss-b2b-variant-price', '');
      priceElement.removeAttribute('bss-b2b-collection-element');
    });

    return true;
  }

  function getBssQuickViewFormId(elements) {
    const bss = window.BSS_B2B;
    const productFormIdAttribute = bss?.enum?.PRODUCT_FORM_ID || 'bss-b2b-product-form-id';

    return elements.quickViewForm?.getAttribute(productFormIdAttribute) || '';
  }

  function resetBssTaxDisplayState(variant, bss) {
    if (!variant) return null;

    const cleanVariant = Object.assign({}, variant);
    const taxDisplayKey = bss?.enum?.TD_KEY || 'td';

    delete cleanVariant.appliedTD;
    delete cleanVariant.bssB2BPriceBeforeTD;
    delete cleanVariant.bssB2BPriceAfterTD;

    if (cleanVariant.bssB2bShowPriceKey === taxDisplayKey) {
      if (cleanVariant.bssB2bPreviousShowPriceKey) {
        cleanVariant.bssB2bShowPriceKey = cleanVariant.bssB2bPreviousShowPriceKey;
      } else {
        delete cleanVariant.bssB2bShowPriceKey;
      }
    }

    delete cleanVariant.bssB2bPreviousShowPriceKey;

    return cleanVariant;
  }

  function syncBssQuickViewProductFormStorage(elements, resetTaxDisplay = false) {
    const bss = window.BSS_B2B;
    const formId = getBssQuickViewFormId(elements);
    const productKey = Number(elements.productId);
    const variantKey = Number(elements.variantId);

    if (!bss?.storage || !formId || !Number.isFinite(productKey)) return;

    const storedProduct = bss.storage.productStorage?.get?.(productKey);
    const fallbackProduct = elements.productData && Number(elements.productData.id) === productKey
      ? elements.productData
      : null;
    const product = storedProduct || fallbackProduct;

    if (!product) return;

    const storedVariant = Number.isFinite(variantKey)
      ? bss.storage.variantStorage?.get?.(variantKey)
        || product.variants?.find?.((variant) => Number(variant.id) === variantKey)
      : null;
    const currentVariant = resetTaxDisplay
      ? resetBssTaxDisplayState(storedVariant, bss)
      : storedVariant;
    const productFormData = Object.assign({}, product, {
      // Tax Display applies product-page rules only to forms marked as "main".
      location: bss.enum?.OProductFormType?.MAIN || 'main'
    });

    if (resetTaxDisplay) {
      delete productFormData.appliedTD;
    }

    if (currentVariant) {
      productFormData.currentVariant = currentVariant;
      bss.storage.variantStorage?.set?.(variantKey, currentVariant);
    }

    bss.storage.productFormStorage?.set?.(formId, productFormData);
  }

  async function loadBssQuickViewStorage(elements) {
    const bss = window.BSS_B2B;
    const productKey = Number(elements.productId);
    const variantKey = Number(elements.variantId);

    if (!bss?.storage || !Number.isFinite(productKey)) return;

    try {
      if (!bss.storage.productStorage?.has?.(productKey)) {
        await bss.storage.productStorage?.load?.([productKey]);
      }

      if (Number.isFinite(variantKey) && !bss.storage.variantStorage?.has?.(variantKey)) {
        await bss.storage.variantStorage?.load?.(new Map([[productKey, [variantKey]]]));
      }
    } catch (error) {
      console.warn('Unable to load BSS quick view price data.', error);
    }
  }

  function dispatchBssQuickViewLoaded(elements) {
    const eventName = 'bss_b2b:QuickviewLoaded';
    const event = new Event(eventName, { bubbles: true });

    elements.quickViewForm.dispatchEvent(event);
  }

  async function notifyBssQuickViewVariantChange(elements) {
    const bss = window.BSS_B2B;
    const productSubject = bss?.observer?.productSubject;

    if (!productSubject?.notifyObserver) return false;

    syncBssQuickViewProductFormStorage(elements, true);

    try {
      await productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
        event: {
          target: elements.variantInput || elements.quickViewForm
        },
        productForm: elements.quickViewForm
      });
    } catch (error) {
      console.warn('Unable to refresh the BSS quick view variant.', error);
      return false;
    }

    return true;
  }

  function renderBssQuickViewTaxDisplay(elements) {
    const bss = window.BSS_B2B;
    const formId = getBssQuickViewFormId(elements);
    const variantId = Number(elements.variantId);
    const showTaxDisplayPrice = bss?.td?.utils?.product?.showPrice;

    if (!bss?.td?.status || !showTaxDisplayPrice || !formId || !Number.isFinite(variantId)) return false;

    syncBssQuickViewProductFormStorage(elements);

    try {
      showTaxDisplayPrice(formId, variantId);
      return true;
    } catch (error) {
      console.warn('Unable to render BSS tax display price in quick view.', error);
      return false;
    }
  }

  function normalizeBssQuickViewPriceLabels(context = document) {
    const root = context?.id === 'quickview-product-content'
      ? context
      : context?.querySelector?.('#quickview-product-content') || document.getElementById('quickview-product-content');

    if (!root) return;

    [
      ['.bss-b2b-price-has-vat', 'brutto'],
      ['.bss-b2b-price-no-vat', 'netto']
    ].forEach(([selector, label]) => {
      root.querySelectorAll(selector).forEach((priceElement) => {
        if (/\b(netto|brutto)\b/i.test(priceElement.textContent || '')) {
          priceElement.removeAttribute('data-bss-tax-label');
          return;
        }

        priceElement.setAttribute('data-bss-tax-label', label);
      });
    });
  }

  function getQuickViewPriceKey(elements) {
    if (!elements?.productId || !elements?.variantId) return '';

    return `${elements.productId}:${elements.variantId}`;
  }

  function setQuickViewPriceLoading(context = document, isLoading = true) {
    const root = context?.id === 'quickview-product-content'
      ? context
      : context?.querySelector?.('#quickview-product-content') || document.getElementById('quickview-product-content');

    if (!root) return;

    root.querySelectorAll('[id^="price-"]').forEach((priceContainer) => {
      priceContainer.classList.toggle('is-bss-price-loading', isLoading);

      if (isLoading) {
        priceContainer.setAttribute('aria-busy', 'true');
      } else {
        priceContainer.removeAttribute('aria-busy');
      }
    });
  }

  function hasCurrentBssQuickViewPrice(elements) {
    const priceKey = getQuickViewPriceKey(elements);
    const hasBssPrice = elements.root?.querySelector?.(
      '.bss-b2b-price-no-vat, .bss-b2b-price-has-vat'
    );

    return !!priceKey
      && elements.root?.dataset.bssQuickViewPriceKey === priceKey
      && !!hasBssPrice;
  }

  function waitForQuickViewPrice(delay) {
    return new Promise((resolve) => setTimeout(resolve, delay));
  }

  let quickViewPriceTimer;
  let quickViewPriceFallbackTimer;
  let quickViewPriceSequence = 0;
  let quickViewPriceRun = Promise.resolve();

  async function renderQuickViewPrice(context = document, sequence = ++quickViewPriceSequence) {
    try {
      for (let attempt = 0; attempt <= 20; attempt += 1) {
        if (sequence !== quickViewPriceSequence) return false;

        const elements = getBssQuickViewElements(context);

        if (!syncBssQuickViewAttributes(elements)) return false;

        if (hasCurrentBssQuickViewPrice(elements)) {
          normalizeBssQuickViewPriceLabels(elements.root);
          return true;
        }

        const bss = window.BSS_B2B;

        if (!bss?.observer?.productSubject) {
          await waitForQuickViewPrice(150);
          continue;
        }

        await loadBssQuickViewStorage(elements);

        if (sequence !== quickViewPriceSequence) return false;

        const productFormIdAttribute = bss.enum?.PRODUCT_FORM_ID || 'bss-b2b-product-form-id';
        const hasBssFormId = elements.quickViewForm.hasAttribute(productFormIdAttribute);

        if (!hasBssFormId) {
          dispatchBssQuickViewLoaded(elements);
          await waitForQuickViewPrice(120);
          continue;
        }

        const priceRefreshed = await notifyBssQuickViewVariantChange(elements);

        if (!priceRefreshed || sequence !== quickViewPriceSequence) return false;

        const refreshedElements = getBssQuickViewElements(context);
        renderBssQuickViewTaxDisplay(refreshedElements);
        normalizeBssQuickViewPriceLabels(refreshedElements.root);
        refreshedElements.root.dataset.bssQuickViewPriceKey = getQuickViewPriceKey(refreshedElements);
        return true;
      }

      return false;
    } finally {
      if (sequence === quickViewPriceSequence) {
        clearTimeout(quickViewPriceFallbackTimer);
        setQuickViewPriceLoading(context, false);
      }
    }
  }

  function scheduleQuickViewPrices(context = document) {
    const elements = getBssQuickViewElements(context);

    if (hasCurrentBssQuickViewPrice(elements)) {
      normalizeBssQuickViewPriceLabels(elements.root);
      setQuickViewPriceLoading(context, false);
      return;
    }

    const sequence = ++quickViewPriceSequence;

    clearTimeout(quickViewPriceTimer);
    clearTimeout(quickViewPriceFallbackTimer);
    setQuickViewPriceLoading(context, true);

    // Never leave the price hidden if the external app is unavailable.
    quickViewPriceFallbackTimer = setTimeout(() => {
      if (sequence === quickViewPriceSequence) {
        setQuickViewPriceLoading(context, false);
      }
    }, 4000);

    quickViewPriceTimer = setTimeout(() => {
      // BSS observers are serialized so reopening Quick View cannot start
      // several expensive price calculations at the same time.
      quickViewPriceRun = quickViewPriceRun
        .catch(() => false)
        .then(() => renderQuickViewPrice(context, sequence));
    }, 80);
  }

  function cancelQuickViewPrices(context = document) {
    quickViewPriceSequence += 1;
    clearTimeout(quickViewPriceTimer);
    clearTimeout(quickViewPriceFallbackTimer);
    setQuickViewPriceLoading(context, false);
  }

  function initQuickViewIntegrations(context = document) {
    updateStoqQuickViewNotify(context);
    scheduleQuickViewPrices(context);
  }

  function getQuickViewContent() {
    return document.getElementById('quickview-product-content') || document;
  }

  function refreshQuickViewIntegrations() {
    const quickViewContent = getQuickViewContent();
    initQuickViewIntegrations(quickViewContent);
  }

  document.addEventListener('eurus:product-page-variant-select:updated:quick-view', () => {
    const quickViewContent = getQuickViewContent();

    setTimeout(() => {
      updateStoqQuickViewNotify(quickViewContent);
      scheduleQuickViewPrices(quickViewContent);
    }, 0);
  });

  document.addEventListener('variant:change', (event) => {
    if (!event.target?.closest?.('#quickview-product-content')) return;

    const quickViewContent = getQuickViewContent();

    setTimeout(() => {
      updateStoqQuickViewNotify(quickViewContent);
      scheduleQuickViewPrices(quickViewContent);
    }, 0);
  });

  const stoqPopupObserver = new MutationObserver(() => protectStoqPopupEvents(document));

  stoqPopupObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(notifyButtonSelector);

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    openStoqQuickViewModal(button);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.bssQuickViewRefresh) return;
    if (!event.target.matches?.('#QuickView input[name="id"], .quick-view input[name="id"]')) return;

    setTimeout(() => {
      const quickViewContent = getQuickViewContent();
      updateStoqQuickViewNotify(quickViewContent);
    }, 0);
  });

  window.addEventListener('stoq:loaded', () => updateStoqQuickViewNotify(document));
  window.initStoqQuickViewNotify = updateStoqQuickViewNotify;
  window.refreshBssQuickViewPrices = scheduleQuickViewPrices;
  window.renderBssQuickViewPrice = scheduleQuickViewPrices;
  window.renderQuickViewPrice = scheduleQuickViewPrices;
  window.scheduleBssQuickViewPrices = scheduleQuickViewPrices;
  window.scheduleQuickViewPrices = scheduleQuickViewPrices;
  window.cancelBssQuickViewPrices = cancelQuickViewPrices;
  window.initQuickViewIntegrations = initQuickViewIntegrations;

  protectStoqPopupEvents(document);
  requestAnimationFrame(refreshQuickViewIntegrations);
})();

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xQuickView', {
      sectionId: window.xQuickView.sectionId,
      enabled: window.xQuickView.enabled,
      buttonLabel: window.xQuickView.buttonLabel,
      show_atc_button: window.xQuickView.show_atc_button,
      btn_atc_bottom: window.xQuickView.atc_btn_bottom,
      atc_btn_image_desktop: window.xQuickView.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",
      popupCloseTimer: null,
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(enable, showATCButton, textBtn) {
        this.enabled = enable;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el, optionId) {
        this.loading = true;

        requestAnimationFrame(() => {
          setTimeout(() => { 
            if (this.buttonQuickView == '') {
              this.buttonQuickView = el;
            }
            let variant = document.getElementById('current-variant-' + optionId)?.innerText;
            let productUrl = variant?`${url}?variant=${variant}&section_id=${this.sectionId}`:`${url}?section_id=${this.sectionId}`;
            productUrl = productUrl.replace(/\s+/g, '');
            
            if (this.cachedResults[productUrl]) {
              document.getElementById('quickview-product-content').innerHTML = this.cachedResults[productUrl];
              const quickViewContent = document.getElementById('quickview-product-content');
              window.initQuickViewIntegrations?.(quickViewContent);
              this.loading = false;
              return true;
            }
            
            if (this.cachedfetch[productUrl]) {
              return true;
            }

            this.cachedfetch[productUrl] = true;
            fetch(productUrl)
              .then(reponse => {
                return reponse.text();
              })
              .then((response) => {
                const parser = new DOMParser();
                const content = parser.parseFromString(response,'text/html').getElementById("quickview-product-content").innerHTML;
                document.getElementById('quickview-product-content').innerHTML = content;
                const quickViewContent = document.getElementById('quickview-product-content');
                window.initQuickViewIntegrations?.(quickViewContent);
                this.cachedResults[productUrl] = content;
              })
              .finally(() => {
                this.loading = false;
                this.cachedfetch[productUrl] = false;
              })

            return true;
          }, 0)
        });
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => { 
          let getVariant = document.getElementById('current-variant-' + optionId)?.innerText;
          let urlProduct = getVariant?`${url}?variant=${getVariant}&section_id=choose-option&page=${index}`:`${url}?section_id=choose-option&page=${index}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            if (window.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');  
              }
            } else {
              if (!el.closest('.card-product').querySelector('#choose-options-mobile')) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => response.text()).then((content) => {
                const parser = new DOMParser();
                const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
                
                if (parsedContent) {
                  if (window.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    destinationElm && (destinationElm.innerHTML = '');
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);  
                if (window.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }      
              });
            }
            this.loadingChooseOption = false;
          } catch (error) {
            console.log(error);
          }
        }, 0)
      },
      open(isMiniCart = false) {
        clearTimeout(this.popupCloseTimer);
        this.popupCloseTimer = null;
        this.show = true;
        this.isMiniCart = isMiniCart;
        Alpine.store('xPopup').open = true;
        setTimeout(() => window.initQuickViewIntegrations?.(document.getElementById('quickview-product-content') || document), 0);
      },
      close() {
        this.show = false;
        window.cancelBssQuickViewPrices?.(document.getElementById('quickview-product-content') || document);
        this.releaseFocusQuickView();
        this.buttonQuickView = '';

        clearTimeout(this.popupCloseTimer);
        if (!Alpine.store('xMiniCart')?.open) {
          this.popupCloseTimer = setTimeout(() => {
            if (!this.show && !Alpine.store('xMiniCart')?.open) {
              Alpine.store('xPopup').open = false;
            }
            this.popupCloseTimer = null;
          }, 500);
        }
      },
      focusQuickView(quickView, btnClose) {
        if (this.show && !this.selected) {
          Alpine.store('xFocusElement')?.trapFocus(quickView, btnClose);
        }
      },
      releaseFocusQuickView() {
        if (this.selected) return;

        const focusStore = Alpine.store('xFocusElement');
        const focusListeners = focusStore?.listeners || {};
        const elementToFocus = this.buttonQuickView?.isConnected
          ? this.buttonQuickView
          : document.getElementById('button_quickview');

        if (focusListeners.focusin) document.removeEventListener('focusin', focusListeners.focusin);
        if (focusListeners.focusout) document.removeEventListener('focusout', focusListeners.focusout);
        if (focusListeners.keydown) document.removeEventListener('keydown', focusListeners.keydown);

        try {
          focusStore?.removeTrapFocus();
        } catch (error) {
          // Closing the modal must not depend on restoring a stale focus target.
        } finally {
          if (focusStore) focusStore.listeners = {};
        }

        requestAnimationFrame(() => {
          if (!this.show && elementToFocus?.isConnected) elementToFocus.focus();
        });
      },
      removeFocusQuickView() {
        this.releaseFocusQuickView();
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }       
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.close();
        } else if (evt.target === evt.currentTarget || evt.target.classList.contains('x-overlay')) {
          this.close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });
  });
});
